module.exports = __webpack_public_path__ + "static/media/RP-77.9b5a5f51.pdf";